import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { newTherapyTemplateAction, therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST,
  DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS,
  DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE,
  DELETE_MDS_ASSESSMENT_BY_DATE_RESET,
  DELETE_MDS_ASSESSMENT_BY_DATE_LOADING,
  UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
} = therapyPlanningAction;

function* deleteMdsAssessmentByDate(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_MDS_ASSESSMENT_BY_DATE_LOADING });
    const response = yield call(therapyPlanningService.deleteMdsAssessmentByDate, payload.payload);
    if (response?.status === 200) {
      yield put({
        type: UPDATE_UNCOVERED_DAY_THERAPY_PLANNING_REQUEST,
        payload: {
          patientId: payload?.payload?.patientId,
          params: {
            date: payload?.payload?.param?.date,
            uncover: true,
          },
          startDate: payload?.payload?.startDate,
          endDate: payload?.payload?.endDate,
        },
      });
      yield put({
        type: DELETE_MDS_ASSESSMENT_BY_DATE_SUCCESS,
        payload: response?.data,
      });
    } else throw response;
  } catch (error) {
    yield put({ type: DELETE_MDS_ASSESSMENT_BY_DATE_FAILURE, payload: error });
  }
}

function* deleteMdsAssessmentByDateSaga() {
  yield takeEvery(DELETE_MDS_ASSESSMENT_BY_DATE_REQUEST, deleteMdsAssessmentByDate);
}

export default deleteMdsAssessmentByDateSaga;
